import { makeStyles, shorthands } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

export const useNavigateBarStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: isMobile ? 'column-reverse' : 'row', // Mobile: Sidebar at the bottom, Desktop: Sidebar on the left
    width: '100%',
    height: '100%',
  },
  tabList: {
    rowGap: customTokens.spacingVerticalS,
    flexShrink: 0, // Prevent sidebar from shrinking
    width: isMobile ? '100%' : '30%', // Full width on mobile, 30% width on desktop
    borderRight: isMobile ? 'none' : `${customTokens.strokeWidthThin} solid ${customTokens.colorNeutralStroke2}`,
    borderTop: isMobile ? `${customTokens.strokeWidthThin} solid ${customTokens.colorNeutralStroke2}` : 'none',
    paddingTop: customTokens.spacingVerticalS,
    paddingRight: isMobile ? customTokens.spacingHorizontalS : customTokens.spacingHorizontalNone,
    paddingBottom: customTokens.spacingVerticalS,
    paddingLeft: customTokens.spacingHorizontalS,
  },
  contentArea: {
    flexGrow: 1, // Content takes up remaining space
    ...shorthands.padding(customTokens.spacingVerticalS, customTokens.spacingHorizontalS),
  },
  contentTab: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: customTokens.spacingHorizontalS,
  },
  tab: {
    'height': '48px',
    'borderRadius': customTokens.borderRadiusNone,
    'padding': `${customTokens.spacingVerticalS} ${customTokens.spacingVerticalS} ${customTokens.spacingVerticalS} ${customTokens.spacingVerticalS}`,
    'textAlign': 'left',
    '& > span': {
      fontWeight: customTokens.fontWeightRegular,
    },
    '& > span:first-of-type': {
      width: customTokens.fontSizeHero800,
      height: customTokens.fontSizeHero800,
    },
    '& .tab-icon': {
      color: customTokens.colorCompoundBrandForeground1,
    },
    '&:enabled:hover .tab-icon': {
      color: customTokens.colorCompoundBrandForeground2Hover,
    },
    '&:after': {
      height: '100%',
      top: customTokens.spacingVerticalNone,
    },
    '&:before': {
      height: '100%',
      top: customTokens.spacingVerticalNone,
    },
  },
  tabDeskTop: {
    '&:after': {
      right: customTokens.spacingVerticalNone,
      left: 'auto',
    },
    '&:before': {
      right: customTokens.spacingVerticalNone,
      left: 'auto',
    },
  },
});
